module.exports = __webpack_public_path__ + "app/assets/images/man11-b018d0df68990248b870e6f530fff321.jpg";